//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'NovaDynaForm',
  props: {
    height: {
      type: [String, Number],
      default: 'auto',
    },
    formUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    isDynamicHeight() {
      return this.height === 'auto';
    },
    heightStyle() {
      return (typeof this.height) === 'string' ? this.height : `${this.height}px`;
    },
  },
};
